import { render, staticRenderFns } from "./ConfirmPayLinks.vue?vue&type=template&id=3484a290&scoped=true"
import script from "./ConfirmPayLinks.vue?vue&type=script&lang=js"
export * from "./ConfirmPayLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3484a290",
  null
  
)

export default component.exports